import React, { useState, useEffect } from "react";
import {
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { Table } from "antd";
import { useForm } from "react-hook-form";
import S3FileUpload from "react-s3";
import moment from "moment";
import Swal from "sweetalert2";
import Loading from "../../components/Common/Loading";

function Team(props) {
  const [events, setEvents] = useState([]);
  const user = useSelector((state) => state.User);
  const [image, setImage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
    reset,
  } = useForm();

  // AWS Config
  const config = {
    bucketName: process.env.REACT_APP_BUCKET_NAME,
    dirName: "team",
    region: "eu-central-1",
    accessKeyId: process.env.REACT_APP_ACCESS_ID,
    secretAccessKey: process.env.REACT_APP_ACCESS_SECRET,
  };

  // HandleImageUpload
  const uploadImage = (event) => {
    const file = event.target.files[0];

    S3FileUpload.uploadFile(file, config)
      .then((data) => {
        setImage(
          `https://${config.bucketName}.s3.${config.region}.amazonaws.com/${data.key}`
        );
      })
      .catch((err) => console.log(err));
  };

  // Toggle modal
  const toggleModal = () => {
    setIsOpenModal(!isOpenModal);
  };

  // console.log("user", user);

  // get enquiries
  const getEvents = () => {
    setIsLoading(true);
    apiReq(url.GET_TEAM, {}, "get", {
      Authorization: `Bearer ${user.user?.token}`,
    })
      .then((res) => {
        if (res.success && res.data !== null) {
          setEvents(res.data);
        }
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getEvents();
  }, []);

  // TODO: columns
  const columns = [
    {
      title: "Image",
      render: (text, record, index) => (
        <span>
          <img src={record.image} alt={record.title} width="100" />
        </span>
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
      sorter: (a, b) => a.name.localeCompare(b.name),
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Designation",
      dataIndex: "designation",
      key: "designation",
      sorter: (a, b) => a.designation.localeCompare(b.designation),
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      sorter: (a, b) => a.description.localeCompare(b.description),
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Index",
      dataIndex: "index",
      key: "index",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Date",
      render: (text, record, index) => (
        <span style={{ whiteSpace: "nowrap" }}>
          {moment(record.createdAt).format("DD-MM-YYYY hh:mm A")}
        </span>
      ),
    },
    {
      title: "Action",
      render: (text, record, index) => (
        <div className="d-flex">
          <button
            className="btn btn-success btn-sm mr-2"
            onClick={() => handleEdit(record)}
          >
            <i className="ri-pencil-line"></i>
          </button>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <button
            className="btn btn-danger btn-sm"
            onClick={() => handleDelete(record._id)}
          >
            <i className="ri-delete-bin-line"></i>
          </button>
        </div>
      ),
    },
  ];

  // Todo: handleDelete
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.value) {
        apiReq(url.DELETE_TEAM + id, {}, "delete", {
          Authorization: `Bearer ${user.user?.token}`,
        })
          .then((res) => {
            if (res.success) {
              Swal.fire({
                title: "Deleted!",
                text: res.message,
                icon: "success",
                showConfirmButton: false,
                timer: 1500,
              });
              getEvents();
            }
          })
          .catch((err) => {
            console.log("err>>>", err);
          });
      }
    });
  };

  // Todo: onSubmit
  const onSubmit = (data) => {
    if (selectedItem === null) {
      setIsLoading(true);
      apiReq(
        url.CREATE_TEAM,
        {
          name: data.name,
          description: data.description,
          designation: data.designation,
          linkedin: data.linkedin,
          index: data.index,
          image,
        },
        "post",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          if (res.success && res.data !== null) {
            getEvents();
            setIsOpenModal(false);
            setSelectedItem(null);
            setImage(null);
            reset();
            setIsLoading(false);
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_TEAM + selectedItem._id,
        {
          name: data.name,
          description: data.description,
          designation: data.designation,
          linkedin: data.linkedin,
          index: data.index,
          image,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          if (res.success && res.data !== null) {
            getEvents();
            setSelectedItem(null);
            setIsOpenModal(false);
            setImage(null);
            reset();
            setIsLoading(false);
            Swal.fire({
              title: "Success",
              text: res.message,
              icon: "success",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          setIsLoading(false);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  // Handle edit category
  const handleEdit = (item) => {
    setSelectedItem(item);
    setValue("name", item.name);
    setValue("linkedin", item.linkedin);
    setValue("designation", item.designation);
    setValue("description", item.description);
    setValue("index", item.index);
    setImage(item.image);
    setIsOpenModal(true);
  };

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Modal toggle={toggleModal} isOpen={isOpenModal} size="lg">
          <ModalHeader>
            {selectedItem !== null
              ? "Update member details"
              : "Add new team member"}
          </ModalHeader>
          <ModalBody>
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="mb-3 row">
                <div className="col-md-4">
                  {image ? (
                    <div
                      className="client_image_inner"
                      style={{
                        position: "relative",
                        borderRadius: 5,
                        overflow: "hidden",
                      }}
                    >
                      <span
                        className="img_close_icon"
                        onClick={() => setImage(null)}
                      >
                        <i className="ri-close-fill"></i>
                      </span>
                      <img
                        src={image}
                        alt={"event image"}
                        style={{ width: "100%" }}
                      />
                    </div>
                  ) : (
                    <div className="add_client_btn">
                      <input
                        type="file"
                        className="upload_hidden"
                        onChange={(e) => uploadImage(e)}
                      />
                      <div>
                        <span className="icn">
                          <i className="ri-add-line"></i>
                        </span>
                        <h5 className="title">Add Image</h5>
                        <small className="text-muted mb-0 text-center">
                          <strong>(400X400)</strong>
                        </small>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className="mb-3">
                <label>Full Name</label>
                <input
                  type="text"
                  className="form-control"
                  {...register("name", { required: true })}
                />
                {errors.name && (
                  <span className="text-danger">Name is required</span>
                )}
              </div>
              <div className="mb-3">
                <label>Designation</label>
                <input
                  type="text"
                  className="form-control"
                  {...register("designation", { required: true })}
                />
                {errors.designation && (
                  <span className="text-danger">Designation is required</span>
                )}
              </div>
              <div className="mb-3">
                <label>Index </label>
                <input
                  type="number"
                  className="form-control"
                  defaultValue={0}
                  {...register("index", { required: true })}
                />
                {errors.index && (
                  <span className="text-danger">Index is required</span>
                )}
              </div>
              <div className="mb-3">
                <label>Linkedin url </label>
                <input
                  type="text"
                  className="form-control"
                  {...register("linkedin", { required: true })}
                />
                {errors.linkedin && (
                  <span className="text-danger">Linkedin is required</span>
                )}
              </div>
              <div className="mb-3">
                <label>Description</label>
                <textarea
                  className="form-control"
                  {...register("description", { required: true })}
                />
                {errors.description && (
                  <span className="text-danger">Description is required</span>
                )}
              </div>
              <ModalFooter>
                <button
                  className="btn btn-secondary"
                  type="button"
                  onClick={toggleModal}
                >
                  Cancel
                </button>
                <button className="btn btn-primary" type="submit">
                  Save
                </button>
              </ModalFooter>
            </form>
          </ModalBody>
        </Modal>
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-md-6">
                  <h5 className="card-title">Team members</h5>
                </div>
                <div className="col-md-6">
                  <div className="d-flex justify-content-end">
                    <button
                      className="btn btn-primary"
                      onClick={() => setIsOpenModal(!isOpenModal)}
                    >
                      Add new team member
                    </button>
                  </div>
                </div>
              </div>
              <hr />
              <Table
                columns={columns}
                dataSource={events}
                bordered
                loading={isLoading}
              />
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Team;
